import React from 'react';
import { arrayOf, func, string, node } from 'prop-types';
import { asyncFieldShape, LoadingState } from './asyncField.js';

// Component which will conditionally render values, based on asyncField patterns.
// Handles intiial, error, loading, success states.
// Works for multiple properties being passed in.
function Loadable(_ref) {
  var properties = _ref.properties,
    render = _ref.render,
    errorRender = _ref.errorRender,
    containerClass = _ref.containerClass,
    LoadingSpinner = _ref.LoadingSpinner;
  var loadingStates = properties.map(function (property) {
    return property.loadingState;
  });
  if (loadingStates.indexOf(LoadingState.ERROR) !== -1) {
    if (errorRender) {
      return errorRender(properties);
    }
    return null;
  }
  if (loadingStates.indexOf(LoadingState.FETCH) !== -1) {
    return /*#__PURE__*/React.createElement("div", {
      className: containerClass
    }, LoadingSpinner && /*#__PURE__*/React.createElement(LoadingSpinner, null));
  }
  if (loadingStates.every(function (loadingState) {
    return loadingState === LoadingState.SUCCESS;
  })) {
    return render(properties);
  }
  return null;
}
Loadable.propTypes = {
  properties: arrayOf(asyncFieldShape),
  render: func,
  errorRender: func,
  containerClass: string,
  LoadingSpinner: node
};
Loadable.defaultProps = {
  properties: [],
  errorRender: undefined,
  containerClass: undefined,
  LoadingSpinner: null,
  render: function render(properties) {
    return properties;
  }
};

export { Loadable as default };
